__turbopack_context__.v({
  "icon-item": "W0jxqG_icon-item",
  "icon-item-svg": "W0jxqG_icon-item-svg",
  "icon-list-item": "W0jxqG_icon-list-item",
  "no-margin-bottom": "W0jxqG_no-margin-bottom",
});
